<!--  -->
<template>
  <div class="type-aside">
    <div class="serachBar">{{ $t('categoryAttribution') }}</div>
    <el-tree
      :data="data"
      :props="defaultProps"
      node-key="id"
      default-expand-all
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
      highlight-current
      :current-node-key="currentItem"
      ref="dataConfigTree"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <!-- 编辑状态 -->
        <template v-if="node.isEdit">
          <el-input
            v-model="data.name"
            autofocus
            size="mini"
            :ref="'slotTreeInput' + data[NODE_KEY]"
            @blur.stop="handleInput(node, data)"
          ></el-input>
          <el-button type="primary" @click.stop="saveName(node, data)" class="save-btn">{{ $t('determine') }}</el-button>
        </template>
        <template v-else>
          <span v-if="!visible" class="node-txt">{{ node.data.name }}</span>
        </template>
      </span>
    </el-tree>
    <div class="handle-btns">
      <el-button type="primary" @click="append('vis')" plain>{{ $t('addPeer') }}</el-button>
      <el-button type="primary" @click="append('child')" plain>{{ $t('addChild') }}</el-button>
      <el-button type="primary" @click="editOrgunit" plain>{{ $t('edit') }}</el-button>
      <el-button type="danger" @click="remove" plain>{{ $t('delete') }}</el-button>
    </div>
  </div>
</template>
<script>
import { attributeDelete, saveAttribute, updateAttribute, attributeTree } from '@/api/new-device/categoryAttribut'
// 定义随机id
let id = 40339126160
export default {
  data() {
    return {
      visible: false,
      data: [],
      NODE_KEY: 'id',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      treeDialog: false,
      treeFrom: {
        children: '',
        id: '',
        name: '',
        pid: '',
        sortOrder: '',
      },
      // 当前选中的节点
      currentNode: null,
      // 当前选中的节点数据
      currentData: null,
      // 第一个节点
      firstNode: null,
      // 当前选中的节点id
      currentItem: '',
      // 当前选中的节点名称
      typeName: '',
      // 新增或者编辑
      isAdd: true,
    }
  },
  methods: {
    // 新增节点
    append(type) {
      // 如果有一个节点，要选择后新增
      if ((!this.currentNode && this.firstNode) || (!this.currentData && this.firstNode)) {
        this.$message({
          type: 'warning',
          message: this.$t('selectNodeAdd'),
        })
        return
      }
      this.isAdd = true
      if (type === 'vis') {
        // 新增同级
        this.appendVis()
      } else {
        // 新增子级
        const newChild = {
          id: id++,
          name: '',
          children: [],
          pid: this.firstNode ? this.currentData.id : '',
          mediaTypeDtos: [],
          mediaTypeName: null,
          tenantId: this.firstNode ? this.currentData.tenantId : '',
        }
        // 如果有根节点
        if (this.currentNode && this.currentNode.data.children) {
          if (this.currentData && !this.currentData.children) {
            this.$set(this.currentData, 'children', [])
          }
          this.currentNode.data.children.push(newChild)
        } else {
          // 无根节点（可新增）
          this.data.push(newChild)
        }
        this.handlefilter(newChild)
      }
    },
    // 新增同级
    appendVis() {
      const newVis = {
        id: id++,
        name: '',
        children: [],
        pid: this.firstNode ? this.currentData.pid : '',
        mediaTypeDtos: [],
        mediaTypeName: null,
        tenantId: this.firstNode ? this.currentData.tenantId : '',
      }
      if (this.currentNode && this.currentNode.parent.data.children) {
        this.currentNode.parent.data.children.push(newVis)
      } else {
        this.data.push(newVis)
      }
      console.log(this.currentData, newVis)
      this.handlefilter(newVis.id)
    },
    // 聚焦新节点框
    handlefilter(id) {
      this.$nextTick(() => {
        this.$refs.dataConfigTree.setCurrentKey(id)
        this.currentNode = this.$refs.dataConfigTree.getNode(id)
        this.currentData = this.currentNode.data

        // 设置编辑状态

        if (!this.currentNode.isEdit) {
          this.$set(this.currentNode, 'isEdit', true)
        }
        // 输入框聚焦
        this.$nextTick(() => {
          if (this.$refs['slotTreeInput' + this.currentData[this.NODE_KEY]]) {
            this.$refs['slotTreeInput' + this.currentData[this.NODE_KEY]].$refs.input.focus()
          }
        })
      })
    },
    // 提交新增
    submitAdd(param) {
      saveAttribute(param).then(res => {
        if (res.state === 0) {
          this.$message({ type: 'success', message: this.$t('AddSuccess') })
          this.getOusTree()
          this.currentNode = null
        }
      })
    },
    // 删除归属
    remove(node, data) {
      if (!this.currentData) {
        this.$message.error(this.$t('selectNodeDelect'))
        return
      }
      if (this.currentData.children && this.currentData.children.length !== 0) {
        this.$message.error(this.$t('nodeChildrenDelete'))
        return
      } else if (this.currentData && this.currentData.id) {
        this.$confirm(this.$t('deleteThisNode'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.removeList(node, this.currentData)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('deletionCancelled'),
            })
          })
      }
    },

    // 当前机构/用户
    handleNodeClick(data, node) {
      this.$refs.dataConfigTree.setCurrentKey(node.id)
      this.currentNode = node
      this.currentData = data
      
      // 点击触发父组件查询
      this.$emit('handleCurrent', this.currentData)
    },
    saveName(node, data) {
      if (this.isAdd) {
        // 新增节点，如果为空 失去焦点删除
        if (this.currentData.name === '') {
          const parent = this.currentNode.parent
          const children = parent.data.children || parent.data
          const index = children.findIndex(d => d.id === this.currentData.id)
          children.splice(index, 1)
          this.currentData = null
          this.currentNode = null
        } else {
          this.submitAdd(this.currentData)
        }
      } else {
        // 编辑状态
        if (this.currentData.name === '') {
          this.message.error(this.$t('enterName'))
          return
        }
        this.submitEditTree()
      }
    },
    // 可编辑input 失去焦点
    handleInput(_node, _data) {
      console.log(_node, _data)
      // 退出编辑状态
      if (_node.isEdit && !_data.name) {
        const parent = this.currentNode.parent
        const children = parent.data.children || parent.data
        const index = children.findIndex(d => d.id === this.currentData.id)
        children.splice(index, 1)
        this.$set(this.currentNode, 'isEdit', false)
        this.currentData = null
        this.currentNode = null
      }
    },
    // 提交编辑
    submitEditTree() {
      if (this.currentData.name && this.currentData.name.length > 20) {
        this.$message.error(this.$t('nameCannotExceed'))
        this.currentData.name = this.typeName
        return false
      }
      updateAttribute(this.currentData).then(res => {
        if (res.state === 0) {
          this.$message({ type: 'success', message: this.$t('EditSucceeded') })
        }
        this.currentNode = null
        this.getOusTree()
      })
    },
    // 归属节点编辑
    editOrgunit() {
      if (!this.currentNode || !this.currentData) {
        this.$message({
          type: 'warning',
          message: this.$t('selectNodeEdit'),
        })
        return
      }
      this.isAdd = false
      this.typeName = this.currentData.name
      console.log(this.currentNode, this.currentData)
      // 设置编辑状态
      if (!this.currentNode.isEdit) {
        this.$set(this.currentNode, 'isEdit', true)
      }
      // 输入框聚焦
      this.$nextTick(() => {
        if (this.$refs['slotTreeInput' + this.currentData[this.NODE_KEY]]) {
          this.$refs['slotTreeInput' + this.currentData[this.NODE_KEY]].$refs.input.focus()
        }
      })
    },
    // 移除组织架构节点
    removeList(node, data) {
      let params = {
        id: data.id,
      }
      attributeDelete(params).then(res => {
        if (res.state === 0) {
          // 删除显示的节点
          const parent = this.currentNode.parent
          const children = parent.data.children || parent.data
          const index = children.findIndex(d => d.id === this.currentData.id)
          children.splice(index, 1)
          this.$message({
            type: 'success',
            message: this.$t('deleteSuccess'),
          })
          this.currentData = null
          this.getOusTree()
        }
      })
    },
    // 获取归属树数据
    getOusTree() {
      let params = {
        name: '',
        isContainMediaType: 1,
        isReject: 1, // 1:不包含类别， 0：包含类别
      }
      attributeTree(params).then(res => {
        if (res.state === 0) {
          this.data = res.value
          this.firstNode = res.value && res.value[0] ? res.value[0] : null
        }
      })
    },
  },
  mounted() {
    this.getOusTree()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
.type-aside
  position relative
  bottom: 0;
  top: 0;
  left: 0;
  background-color: #eff1f4;
  width 19%!important
  height: 100%;
  .handle-btns
    position: absolute;
    left: 10px;
    bottom: 10px;
    .el-button
      margin-right 10px
      float: left;
      padding 5px 10px
      &:last-child
        margin-right 0
  .serachBar
    padding 10px
    font-weight: bold
    font-size 16px
    color #222
    background: #e2e6ec
  .serachBtn
    margin-left 40%
  .serachBar:before
    display inline-block
    content ''
    width 3px
    height 15px
    margin-right 10px
    border-radius 3px
    background-color #0e65dd
    .el-input
      width 100%
  .editBtn
    display none
    .addicon
      margin-right 10%
      width 20px
      height 20px
  .custom-tree-node
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .node-txt
      font-size 16px;/*no*/
    >>>.save-btn
      margin-left 10px
      padding 5px 10px;/*no*/
  >>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content
      color: #2372df !important;
  >>>.el-tree
    height 88%
    overflow auto
    border-top: var(--aside-tree-border-bottom);
    color: var(--table-color);
.el-button--primary.is-plain
  color #409EFF
  background: #ecf5ff;
  border-color: #b3d8ff;
.theme-dark
  .el-button--primary.is-plain
    color #002A96
    background: #00DEFF;
    border-color: #00DEFF;
  .type-aside
    background-color: #042a85;
    .serachBar
      color #fff
      background: #002799
      &:before
        background: #00DDFE
    >>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content
      color: #fff !important;
</style>
